"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, BLUR_PLACEHOLDER, getFocusPointStyle, ImageMetadata } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  href?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export const VerticalBigImageNews = t0 => {
  const $ = _c(50);
  const {
    title: t1,
    excerpt: t2,
    timeAgo: t3,
    imageSrc: t4,
    slug,
    href,
    priority: t5,
    imageMetadata
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "\u0B9C\u0BC7\u0B86\u0BB0\u0BCD\u0B9C\u0BBF \u0BAA\u0BC1\u0BB0\u0B9F\u0BC6\u0B95\u0BCD\u200C\u0BB7\u0BA9\u0BCD\u0BB8\u0BCD \u0B9A\u0BBE\u0BB0\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD \u0B8E\u0BA9\u0BCD.\u0B9C\u0BC0\u0BB5\u0BBE\u0BA9\u0BA8\u0BCD\u0BA4\u0BAE\u0BCD \u0BA4\u0BAF\u0BBE\u0BB0\u0BBF\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD \u0B89\u0BB0\u0BC1\u0BB5\u0BBE\u0B95\u0BBF\u0BAF\u0BC1\u0BB3\u0BCD\u0BB3 \u0B87\u0BAA\u0BCD\u0BAA\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BB0\u0BBE\u0B9C\u0BB2\u0B9F\u0BCD\u0B9A\u0BC1\u0BAE\u0BBF",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const title = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "\u0B9C\u0BC7\u0B86\u0BB0\u0BCD\u0B9C\u0BBF \u0BAA\u0BC1\u0BB0\u0B9F\u0BC6\u0B95\u0BCD\u200C\u0BB7\u0BA9\u0BCD\u0BB8\u0BCD \u0B9A\u0BBE\u0BB0\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD \u0B8E\u0BA9\u0BCD.\u0B9C\u0BC0\u0BB5\u0BBE\u0BA9\u0BA8\u0BCD\u0BA4\u0BAE\u0BCD \u0BA4\u0BAF\u0BBE\u0BB0\u0BBF\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD \u0B89\u0BB0\u0BC1\u0BB5\u0BBE\u0B95\u0BBF\u0BAF\u0BC1\u0BB3\u0BCD\u0BB3 \u0B87\u0BAA\u0BCD\u0BAA\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BB0\u0BBE\u0B9C\u0BB2\u0B9F\u0BCD\u0B9A\u0BC1\u0BAE\u0BBF \u0BA8\u0BBE\u0BAF\u0B95\u0BBF\u0BAF\u0BBE\u0B95 \u0BA8\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BBE\u0BB0\u0BCD.",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const excerpt = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "May 17, 2023",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const timeAgo = t8;
  let t9;
  if ($[6] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const imageSrc = t9;
  const priority = t5 === undefined ? false : t5;
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  const t10 = timeAgo?.value;
  let t11;
  if ($[8] !== t10) {
    t11 = getTimeAgo(t10);
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const timeAgoValue = t11;
  let t12;
  if ($[10] !== imageSrc?.value) {
    t12 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[10] = imageSrc?.value;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const imageSrcValue = t12;
  let t13;
  if ($[12] !== imageMetadata || $[13] !== imageSrc?.customClass || $[14] !== imageSrc?.hidden || $[15] !== imageSrcValue || $[16] !== priority || $[17] !== titleValue) {
    t13 = !imageSrc?.hidden && <div className={` ${imageSrc?.customClass || ""}`}><div className="relative w-full aspect-[16/9] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} className="object-cover w-full h-full" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} priority={priority} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[12] = imageMetadata;
    $[13] = imageSrc?.customClass;
    $[14] = imageSrc?.hidden;
    $[15] = imageSrcValue;
    $[16] = priority;
    $[17] = titleValue;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== title?.customClass || $[20] !== title?.hidden || $[21] !== titleValue) {
    t14 = !title?.hidden && <h3 className={`text-16-tamil-700 leading-[1.4] text-1B1B1B ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[19] = title?.customClass;
    $[20] = title?.hidden;
    $[21] = titleValue;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== excerpt?.customClass || $[24] !== excerpt?.hidden || $[25] !== excerptValue) {
    t15 = !excerpt?.hidden && <p className={`text-12-tamil-400 text-4D4D4D leading-[1.4] line-clamp-1 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[23] = excerpt?.customClass;
    $[24] = excerpt?.hidden;
    $[25] = excerptValue;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== timeAgo?.customClass || $[28] !== timeAgo?.hidden || $[29] !== timeAgoValue) {
    t16 = !timeAgo?.hidden && <span className={`text-12-tamil-500 ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[27] = timeAgo?.customClass;
    $[28] = timeAgo?.hidden;
    $[29] = timeAgoValue;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = slug ? `/${slug}` : undefined;
  let t18;
  if ($[31] !== excerptValue || $[32] !== imageSrcValue || $[33] !== slug || $[34] !== t17 || $[35] !== titleValue) {
    t18 = <div className="flex gap-3"><MessageIcon id="message-icon-3" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t17} /></div>;
    $[31] = excerptValue;
    $[32] = imageSrcValue;
    $[33] = slug;
    $[34] = t17;
    $[35] = titleValue;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16 || $[38] !== t18) {
    t19 = <div className="flex justify-between items-center gap-2">{t16}{t18}</div>;
    $[37] = t16;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t14 || $[41] !== t15 || $[42] !== t19) {
    t20 = <div className="flex flex-col gap-2">{t14}{t15}{t19}</div>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t13 || $[45] !== t20) {
    t21 = <div className="flex flex-col overflow-hidden p-4 gap-4">{t13}{t20}</div>;
    $[44] = t13;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  const content = t21;
  const linkHref = href || (slug ? `/${slug}` : null);
  if (linkHref) {
    let t22;
    if ($[47] !== content || $[48] !== linkHref) {
      t22 = <Link href={linkHref} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[47] = content;
      $[48] = linkHref;
      $[49] = t22;
    } else {
      t22 = $[49];
    }
    return t22;
  }
  return content;
};